import { render, staticRenderFns } from "./Carmi.vue?vue&type=template&id=490db576"
import script from "./Carmi.vue?vue&type=script&lang=js"
export * from "./Carmi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports